/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Danger_Signoutalldesc3Inputs */

const zh_danger_signoutalldesc3 = /** @type {(inputs: Danger_Signoutalldesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这将注销您在所有设备上的会话，包括当前设备。您需要重新登录。`)
};

const en_danger_signoutalldesc3 = /** @type {(inputs: Danger_Signoutalldesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will sign you out on all devices, including the current one. You will need to sign in again.`)
};

const es_danger_signoutalldesc3 = /** @type {(inputs: Danger_Signoutalldesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esto cerrará tu sesión en todos los dispositivos, incluido el actual. Deberás iniciar sesión de nuevo.`)
};

/**
* | output |
* | --- |
* | "This will sign you out on all devices, including the current one. You will need to sign in again." |
*
* @param {Danger_Signoutalldesc3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const danger_signoutalldesc3 = /** @type {((inputs?: Danger_Signoutalldesc3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Danger_Signoutalldesc3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_danger_signoutalldesc3(inputs)
	if (locale === "en") return en_danger_signoutalldesc3(inputs)
	return es_danger_signoutalldesc3(inputs)
});
export { danger_signoutalldesc3 as "danger_signOutAllDesc" }